import { render } from "./CertificateDetail.vue?vue&type=template&id=4b67ef0a"
import script from "./CertificateDetail.vue?vue&type=script&lang=js"
export * from "./CertificateDetail.vue?vue&type=script&lang=js"
script.render = render

export default script